import * as React from "react";

import {UiState} from "../../../core/ui-state";
import {AppState} from "../app-mobx";
import {AppConfiguration} from "../../../core/config/app-configuration";
import {Legend} from "../../../core/components/legend/legend";
import {MapState} from "../../../core/map-state";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import {Item} from "semantic-ui-react";
import {SidebarControlsConfiguration} from "../../../config/sidebar-configuration";
import {observer} from "mobx-react";
import {Auftragsverwaltung} from "../../../stores/auftragsverwaltung-mobx";
import {Icon} from "../../../core/components/icon/icon";
import {ProjectProcess} from "../../../pages/project-process/project-process";
import {ProjectPerimeterEditor} from "../editor/project-perimeter-editor/project-perimeter-editor";
import {LayerList} from "../../../core/components/layer-list/layer-list";


export interface AsideProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
    auftragsverwaltung: Auftragsverwaltung;
    mapViewerConfig: MapViewerConfiguration;
}

@observer
export class Aside extends React.Component<AsideProps, any> {
    uiStore: UiState;
    constructor(props: AsideProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }
    render(): React.ReactElement | null {
        const {auftragsverwaltung, appConfig, appStore, mapStore, mapViewerConfig} = this.props;
        const {asideContent} = appStore;
        const legendConfig = mapViewerConfig.legend;
        const editorConfig = appConfig.editor;
        const apiLayersConfig = mapViewerConfig.auftragsverwaltungApi.layers;
        const items: React.ReactElement[] = [];

        if (!this.props.appStore.showAside) {
            return null;
        }

        // logged in user
        if (appStore.loggedIn) {
            items.push(
                <Item className="logged-in-user" key={"user"}>
                    <Icon name="user"/>{appStore.esriCredential?.userId}
                </Item>
            );
        }

        if (asideContent) {
            items.push(<Item key={"content"}>{asideContent}</Item>);
        }
        if (typeof legendConfig.esriConfig !== "undefined" && auftragsverwaltung.showMap){
            if (auftragsverwaltung.isEditingPerimeter) {
                const controlsConfig = mapViewerConfig as SidebarControlsConfiguration;
                items.push(
                    <Item key={"layer-list"}>
                        <div>
                            <h2><Icon name="map_roads" /> Karteninhalt</h2>
                            <LayerList
                                appConfig={appConfig}
                                appStore={appStore}
                                controlsConfig={controlsConfig}
                                config={controlsConfig.layerList}
                                mapStore={mapStore}
                                small={false}
                                view={mapStore.view}
                                uiStore={this.uiStore} />
                        </div>
                    </Item>
                );
                items.push(
                    <Item key={"editor"}>
                        <ProjectPerimeterEditor
                            appStore={appStore}
                            auftragsverwaltung={auftragsverwaltung}
                            config={editorConfig}
                            mapViewerConfig={mapViewerConfig}
                            layers={apiLayersConfig}
                            mapStore={mapStore}
                            uiStore={this.uiStore} />
                    </Item>
                );
            }
            else {
                items.push(
                    <Item key={"legend"}>
                        <div>
                            <h2><Icon name="list_style_bullets" /> {legendConfig.title}</h2>
                            <Legend
                                appStore={appStore}
                                mapStore={mapStore}
                                uiStore={this.uiStore}
                                view={mapStore.view}
                                config={legendConfig.esriConfig}
                                controlsConfig={mapViewerConfig as SidebarControlsConfiguration}/>
                        </div>
                    </Item>
                );
            }
        }
        if (!auftragsverwaltung.isEditingPerimeter &&
            auftragsverwaltung.selectedProject) {
            items.push(
                <Item key={"process"}>
                    <ProjectProcess
                        project={auftragsverwaltung.selectedProject}
                        appStore={appStore}
                        auftragsverwaltung={auftragsverwaltung}
                        mapViewerConfig={mapViewerConfig}
                    />
                </Item>
            );
        }

        if (items.length === 0) {
            return <aside id="rightContent" className="layout__aside" />;
        } else {
            return (
                <aside id="rightContent" className="layout__aside">
                    <Item.Group divided>
                        {items}
                    </Item.Group>
                </aside>
            );
        }
    }
}
